<template>
    <div class="accordion mergeData" role="tablist">
        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
        <div class="card" v-for="(offer,index) in mergeOffers" :key="index">
            <div class="card-header p-1 accordion-header" role="tab">
                <button class="accordion-button" block v-b-toggle="'accordion-'+index"  variant="info">
                    <span class="cusips">{{offer.cusip.cusip}}</span>
                    <span class="desc">{{offer.cusip.description}}</span> <!--{{index+1}}--></button>
            </div>
            <b-collapse :id="'accordion-'+index" visible accordion="my-accordion" role="tabpanel">
                <div class="card-body">
                   <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                        <tr>
                            <th 
                            scope="col" 
                            class="sort text-left"
                            style="width: 5%"
                            >Select</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            >Qty</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            >Price</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            >COST</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            >OFFER TYPE</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            >SPREAD</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            >YIELD</th>
                            
                        </tr>
                    </thead>
                    <tbody class="list">
                        <tr v-for="(listOffer,listindex) in offer.offerList" :key="'A'+listindex">
                            <td class="text-left"><input v-model="listOffer.isCreateOffer" type="checkbox" class="form-check-input ml-3" id="exampleCheck1"></td>
                            <td class="text-center">{{listOffer.quantity}}</td>
                            <td class="text-center"><span>{{listOffer.price | currency}}</span></td>
                            <td class="text-center">{{listOffer.cost | currency}}</td>
                            <td class="text-center">{{listOffer.offerType}}</td>
                            <td class="text-center">{{(listOffer.price - listOffer.cost).toFixed(2)}}</td>
                            <td class="text-center">{{listOffer.yield}} %</td>
                            
                        </tr>
                        <tr style="background-color:#ffd7d7" v-for="(waitOffer,waitindex) in offer.waitingOffer" :key="'B'+waitindex">
                            <td class="text-left"><input v-model="waitOffer.isCreateOffer" type="checkbox" class="form-check-input ml-3" id="exampleCheck1"></td>
                            <td class="text-center">{{waitOffer.quantity}}</td>
                            <td class="text-center"><span>{{waitOffer.price | currency}}</span></td>
                            <td class="text-center">{{waitOffer.cost | currency}}
                            <td class="text-center">{{waitOffer.offerType}}</td>
                            <td class="text-center">{{(waitOffer.price - waitOffer.cost).toFixed(2)}}</td>
                            <td class="text-center">{{waitOffer.yield}} %</td>
                        </tr>
                    </tbody>
                    </table>
                    <div class="d-flex justify-content-center">
                        <button class="btn btn-outline-success rounded  mb-2" @click="openAddNewOfferModal(offer)">Create new offer</button>
                    </div>

                </div>
            </b-collapse>
        </div> 
         <add-offer
            v-bind:offerCusip="offerCusip"
            v-bind:offerInventory="offerInventory"
            v-bind:mode="'MERGE'"  
            v-bind:waitingOfferingIds="waitingOfferingIds"  
            v-bind:cancelOfferingIds="cancelOfferingIds"  
            v-if="addNewOfferModalOpen" 
            @close="closeOfferPopup()">
        </add-offer>  
  </div>
</template>

<script>
import authService from "@/authService";
import config from "@/config";
import addOffer from "./ImsAddOfferModal"

export default {
  name: "imsMergeFactorComponent",
  components : {
    addOffer
  },
  data() {
    return {
        addNewOfferModalOpen : false,
        offerCusip : null,
        offerInventory : [],
        mergeOffers : null,
        loading : false,
        waitingOfferingIds : [],
        cancelOfferingIds : []

        }
        
  },
  methods: {
    closeOfferPopup(){
        this.addNewOfferModalOpen = false;
        this.getMergeOffers();
    },
    getMergeOffers(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/offer/merge-waiting-offer",
                auth
            )
            .then((result) => {
              this.mergeOffers = result.data;
              this.loading = false;
            })
    },
    openAddNewOfferModal(offers){
        let selectedCusip = offers.cusip;
        this.offerInventory = [];
        this.waitingOfferingIds = [];
        this.cancelOfferingIds = [];
        offers.waitingOffer.forEach((offer) => {
            if(offer.isCreateOffer){
                this.waitingOfferingIds.push(offer.waitingOfferingId);
                offer.inventoryList.forEach((inventory) => {
                    this.offerInventory.push(inventory)
                })
            }
        });
        offers.offerList.forEach((offer) => {
            if(offer.isCreateOffer){
                this.cancelOfferingIds.push(offer.id);
                offer.inventoryList.forEach((inventory) => {
                    this.offerInventory.push(inventory)
                })
            }
        });

        //console.log(offerInventory)
       // this.offerCusip = {"id": 1765};  
       if(this.offerInventory.length > 0){
            if(selectedCusip){
                this.offerCusip = {...selectedCusip};  
            }else{
                this.offerCusip = {};
            }
            this.addNewOfferModalOpen = !this.addNewOfferModalOpen;
       }
    }

  },
  mounted() {
    this.getMergeOffers()
  }
};
</script>
<style  scoped>
    .accordion-button{
        background-color: #eee;
        color: #444;
        cursor: pointer;
        padding: 18px;
        width: 100%;
        border: none;
        text-align: left;
        outline: none;
        font-size: 15px;
        transition: 0.4s;
    }
    .card-text ,p{
        color: #444
    }
    .card {
        margin-bottom: 0px
    }
    .accordion-button:after {
        content: '\002B';
        color: #777;
        font-weight: bold;
        float: right;
        margin-left: 5px;
    }
    .accordion-button.not-collapsed:after {
        content: "\2212";
    }

</style>